import React from 'react'
import { t } from '@lingui/core/macro'
import { useAutoRedirect } from '../../hooks/useAutoRedirect'
import MainButton from '../MainButton/MainButton'
import styles from './MerchantSiteRedirectButton.module.css'

interface Props {
    redirectUrl?: string
    redirectTimeout?: number
}

const MerchantSiteRedirectButton = ({ redirectUrl, redirectTimeout }: Props) => {
    const { secondsLeft, redirect } = useAutoRedirect(redirectUrl, redirectTimeout)

    if (!redirectUrl) {
        return null
    }

    return (
        <div className={styles.returnSection}>
            <MainButton
                message={t`Вернуться на страницу продавца`}
                type="button"
                onClick={redirect}
                disabled={false}
            />
            {secondsLeft !== null && (
                <p className={styles.autoRedirect}>
                    {t`Автоматический переход через ${secondsLeft} сек.`}
                </p>
            )}
        </div>
    )
}

export default MerchantSiteRedirectButton
